<h1>Carrier Sales - Procurement</h1>

<div class="row">
    <div [ngClass]="(editedLoad | json) != '{}' ? 'col-sm-6 col-lg-5 col-xl-3' : 'col-sm-12'">
        <i *ngIf="(editedLoad | json) != '{}'" class="fas fa-angle-double-left fa-2x k-float-right" style="margin-right:-25px;cursor:pointer;" (click)="closeLoad();selectCurrentTab()"></i>

        <div class="epi-container" *ngIf="selectedTab != 'Dashboard'">
            <i class="fa" (click)="toggleFlag('filters')" [ngClass]="{'fa-plus': divFlags['filters'] == false, 'fa-minus': divFlags['filters'] == true}" aria-hidden="true"></i>

            <div *ngIf="divFlags['filters']">
                <div class="row m-0">
                    <div class="border bg-light" [ngClass]="(editedLoad | json) != '{}' ? 'col-sm-12' : 'col-sm-3'">
                        <h3>Primary Filters</h3>
                        <div class="row">
                            <div class="col-sm-6">
                                <label class="fw-bold">Begin Date</label>
                                <kendo-datepicker [(ngModel)]="availableLoadsFilter.beginDate" (valueChange)="filterLoads();filterBookedLoads();filterUnverifiedLoads();" [ngModelOptions]="{standalone: true}"></kendo-datepicker>
                            </div>
                            <div class="col-sm-6">
                                <label class="fw-bold">End Date</label>
                                <kendo-datepicker [(ngModel)]="availableLoadsFilter.endDate" (valueChange)="filterLoads();filterBookedLoads();filterUnverifiedLoads();" [ngModelOptions]="{standalone: true}"></kendo-datepicker>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 text-end">
                                <button style="margin: 5px" class="btn btn-primary" (click)="getLoads(false)">Search</button>
                                <button style="margin: 5px" class="btn btn-secondary" (click)="resetFilters()">Reset Filters</button>
                            </div>
                        </div>
                    </div>
                    <div [ngClass]="(editedLoad | json) != '{}' ? 'col-sm-12' : 'col-sm-9'">
                        <h3>Secondary Filters</h3>
                        <div class="row">
                            <div [ngClass]="(editedLoad | json) != '{}' ? 'col-sm-12' : 'col-sm-4'">
                                <div class="row">
                                    <div class="col">
                                        <input type="checkbox" id="isSpotExpediteContract" style="cursor:pointer;margin:5px;transform: scale(1.5);" [(ngModel)]="availableLoadsFilter.isSpotExpediteContract" (change)="filterLoads()" />
                                        <!--<label class="fw-bold" for="isSpotExpedite" style="margin-right:20px;">Spot/Expedite</label>-->
                                        <label class="fw-bold" for="isSpotExpediteContract" style="margin-right:5px;">Spot/Expedite/Unassigned Contract</label>
                                    </div>
                                </div>
                                <div class="row" *ngIf="selectedTab == 'RFQ'">
                                    <div class="col">
                                        <input type="checkbox" id="isRFQAllCosts" style="cursor: pointer;margin: 5px; transform: scale(1.5);" [(ngModel)]="availableLoadsFilter.isRFQAllCosts" (change)="filterLoads();filterBookedLoads();filterUnverifiedLoads();" />
                                        <label class="fw-bold" for="isRFQAllCosts">All RFQ Costs</label>
                                    </div>
                                </div>
                                <div class="row" *ngIf="selectedTab == 'Carrier Contracts'">
                                    <div class="col">
                                        <input type="checkbox" id="isNonExpired" style="cursor: pointer;margin: 5px; transform: scale(1.5);" [(ngModel)]="availableLoadsFilter.isNonExpired" (change)="filterLoads();filterBookedLoads();filterUnverifiedLoads();" />
                                        <label class="fw-bold" for="isNonExpired">All non-Expired</label>
                                    </div>
                                </div>
                            </div>
                            <div [ngClass]="(editedLoad | json) != '{}' ? 'col-sm-12' : 'col-sm-2'">
                                <input type="checkbox" id="isMyLoads" style="cursor: pointer;margin: 5px; transform: scale(1.5);" [(ngModel)]="availableLoadsFilter.isMyLoads" (change)="filterLoads();filterBookedLoads();filterUnverifiedLoads();" />
                                <label class="fw-bold" for="isMyLoads">My Loads</label>
                            </div>
                            <div [ngClass]="(editedLoad | json) != '{}' ? 'col-sm-12' : 'col-sm-3'">
                                <input type="checkbox" id="isBulkTender" style="cursor: pointer;margin: 5px; transform: scale(1.5);" [(ngModel)]="availableLoadsFilter.isBulkTender" (change)="filterLoads()" />
                                <label class="fw-bold" for="isBulkTender">Bulk Tender</label>
                                <br />
                                <button type="button" (click)="offerBulkTenderLoads()" class="btn btn-primary" [disabled]="isTenderLoads" *ngIf="(editedLoad | json) == '{}' && bulkTenderLoads.length>0">
                                    <span class="fas fa-check-double" aria-hidden="true"></span> Tender Loads
                                </button>
                            </div>
                            <div [ngClass]="(editedLoad | json) != '{}' ? 'col-sm-12 p-2' : 'col-sm-3'">
                                <button type="button" (click)="openDialogClick('CarrierRepsAssignedStats')" class="btn btn-primary btn-lg">
                                    <span class="fas fa-users" aria-hidden="true"></span> Assigned Reps
                                </button>
                            </div>
                            <!--<div [ngClass]="(editedLoad | json) != '{}' ? 'col-sm-6 p-2' : 'col-sm-2'">
                                <button type="button" (click)="getLoads(false)" class="btn btn-success btn-lg">
                                    <span class="fas fa-sync" aria-hidden="true"></span> Refresh
                                </button>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <kendo-tabstrip (tabSelect)="onTabSelect($event)" [hidden]="(editedLoad | json) != '{}'" #topTabStrip>
            <kendo-tabstrip-tab [title]="'Dashboard'" [selected]="isCSRManager" *ngIf="isCSRManager">
                <ng-template kendoTabContent>
                    <div class="row">
                        <div class="col-sm-2">
                            <label class="fw-bold">Start/Due Date</label>
                            <kendo-datepicker [(ngModel)]="dashboardDate" [ngModelOptions]="{standalone: true}"></kendo-datepicker>
                        </div>
                        <div class="col-sm-9">
                            <button type="button" class="btn btn-primary" (click)="getDashboardAvailableLoads()">Get Loads</button>
                        </div>
                        <div class="col-sm-1" *ngIf="isCardDetail">
                            <button type="button" class="btn btn-secondary" (click)="closeCardDetail()">Close Grid</button>
                        </div>
                    </div>
                    <div class="row">
                        <div [ngClass]="isCardDetail ? 'col-sm-3' : 'col-sm-12'">
                            <div class="row">
                                <div class="dashboard-card" [ngClass]="isCardDetail ? 'col-sm-5' : 'col-sm-2'" (click)="cardClick('cardAvailableWithoutHC', 0)">
                                    <div [ngClass]="cardType == 'cardAvailableWithoutHC' ? 'btn btn-primary' : ''">
                                        <h3>Loads w/o Hard Contact</h3>
                                        <h2>{{cardAvailableWithoutHC}}</h2>
                                    </div>
                                </div>
                                <div class="dashboard-card" [ngClass]="isCardDetail ? 'col-sm-5' : 'col-sm-2'" (click)="cardClick('cardAvailableWithoutMaxCarrierPay', 0)">
                                    <div [ngClass]="cardType == 'cardAvailableWithoutMaxCarrierPay' ? 'btn btn-primary' : ''">
                                        <h3>Loads w/o Max Carrier Pay</h3>
                                        <h2>{{cardAvailableWithoutMaxCarrierPay}}</h2>
                                    </div>
                                </div>
                                <div class="dashboard-card" [ngClass]="isCardDetail ? 'col-sm-5' : 'col-sm-2'" (click)="cardClick('cardBookedNegativeProfit', 0)">
                                    <div [ngClass]="cardType == 'cardBookedNegativeProfit' ? 'btn btn-primary' : ''">
                                        <h3>Booked w/ Negative Profit</h3>
                                        <h2>{{cardBookedNegativeProfit}}</h2>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div [ngClass]="isCardDetail ? 'col-sm-12' : 'col-sm-2'">
                                    <h3>Unverified In Transit</h3>
                                    <label class="fw-bold">Carrier Sales Team</label>
                                    <select name="employeeGroupRoleMapID" [(ngModel)]="employeeGroupRoleMapID" class="form-select" (change)="getTeam()">
                                        <option value="0">-- ALL --</option>
                                        <option *ngFor="let team of searchEmployeeGroupRoleMaps" value="{{team.employeeGroupRoleMapID}}">{{team.groupName}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="dashboard-card" [ngClass]="isCardDetail ? 'col-sm-5' : 'col-sm-2'" *ngFor="let csr of cardUnverifiedInTransitList" (click)="cardClick('cardUnverifiedInTransit', csr.employeeID)">
                                    <div [ngClass]="cardType == 'cardUnverifiedInTransit' && cardEmployeeID == csr.employeeID ? 'btn btn-primary' : ''">
                                        <h3>{{csr.employeeName}}</h3>
                                        <h2>{{csr.loadCount}}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9" *ngIf="isCardDetail">
                            <carrier-sales-loads-grid *ngIf="cardType == 'cardAvailableWithoutHC'"
                                                      [loads]="availableWithoutHCList"
                                                      [viewType]="'orders'"
                                                      [selectedLoad]="editedLoad"
                                                      [isShowBulkTender]="availableLoadsFilter.isBulkTender"
                                                      (selectBulkTenderLoads)="selectBulkTenderLoads($event)"
                                                      (onRefresh)="getLoads(false)"
                                                      (onClick)="loadClick($event)">
                            </carrier-sales-loads-grid>
                            <carrier-sales-loads-grid *ngIf="cardType == 'cardAvailableWithoutMaxCarrierPay'"
                                                      [loads]="availableWithoutMaxCarrierPayList"
                                                      [viewType]="'orders'"
                                                      [selectedLoad]="editedLoad"
                                                      [isShowBulkTender]="availableLoadsFilter.isBulkTender"
                                                      (selectBulkTenderLoads)="selectBulkTenderLoads($event)"
                                                      (onRefresh)="getLoads(false)"
                                                      (onClick)="loadClick($event)">
                            </carrier-sales-loads-grid>
                            <carrier-sales-booked-loads-grid *ngIf="cardType == 'cardBookedNegativeProfit'"
                                                             [loads]="bookedNegativeProfitList"
                                                             [viewType]="'booked'"
                                                             [selectedLoad]="editedLoad"
                                                             (onClick)="loadClick($event)"
                                                             (onRemoveCarrier)="refreshAfterOffer()">
                            </carrier-sales-booked-loads-grid>
                            <carrier-sales-unverified-loads *ngIf="cardType == 'cardUnverifiedInTransit'"
                                                            [loads]="unverifiedInTransitByEmployeeList"
                                                            (onClick)="unverifiedLoadClick($event)"
                                                            (onSave)="refreshAfterOffer()">
                            </carrier-sales-unverified-loads>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Orders'" [selected]="!isCSRManager">
                <ng-template kendoTabContent>
                    <carrier-sales-loads-grid *ngIf="availableLoads.length>0"
                                              [loads]="availableLoads"
                                              [viewType]="'orders'"
                                              [selectedLoad]="editedLoad"
                                              [isShowBulkTender]="availableLoadsFilter.isBulkTender"
                                              (selectBulkTenderLoads)="selectBulkTenderLoads($event)"
                                              (onRefresh)="getLoads(false)"
                                              (onClick)="loadClick($event)">
                    </carrier-sales-loads-grid>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Booked'">
                <ng-template kendoTabContent>
                    <carrier-sales-booked-loads-grid *ngIf="bookedLoads.length>0"
                                                     [loads]="bookedLoads"
                                                     [viewType]="'booked'"
                                                     [selectedLoad]="editedLoad"
                                                     (onClick)="loadClick($event)"
                                                     (onRemoveCarrier)="refreshAfterOffer()">
                    </carrier-sales-booked-loads-grid>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Unverified'">
                <ng-template kendoTabContent>
                    <carrier-sales-unverified-loads *ngIf="unverifiedLoads.length>0"
                                                    [loads]="unverifiedLoads"
                                                    (onClick)="unverifiedLoadClick($event)"
                                                    (onSave)="refreshAfterOffer()">
                    </carrier-sales-unverified-loads>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Quotes'">
                <ng-template kendoTabContent>
                    <carrier-sales-loads-grid *ngIf="availableLoads.length>0"
                                              [loads]="availableLoads"
                                              [viewType]="'quotes'"
                                              [selectedLoad]="editedLoad"
                                              (onRefresh)="getLoads(false)"
                                              (onClick)="loadClick($event)">
                    </carrier-sales-loads-grid>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'RFQ'">
                <ng-template kendoTabContent>
                    <carrier-sales-loads-grid *ngIf="availableLoads.length>0"
                                              [loads]="availableLoads"
                                              [viewType]="'rfq'"
                                              [selectedLoad]="editedLoad"
                                              (onRefresh)="getLoads(false)"
                                              (onClick)="loadClick($event)">
                    </carrier-sales-loads-grid>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Open Dedicated'">
                <ng-template kendoTabContent>
                    <carrier-sales-loads-grid *ngIf="availableLoads.length>0"
                                              [loads]="availableLoads"
                                              [viewType]="'open-dedicated'"
                                              [selectedLoad]="editedLoad"
                                              (onRefresh)="getLoads(false)"
                                              (onClick)="loadClick($event)">
                    </carrier-sales-loads-grid>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Carrier Contracts'">
                <ng-template kendoTabContent>
                    <carrier-contract-grid [isNonExpired]="availableLoadsFilter.isNonExpired"></carrier-contract-grid>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Released'">
                <ng-template kendoTabContent>
                    <carrier-sales-released-loads-grid *ngIf="releasedLoads.length>0"
                                                     [loads]="releasedLoads"
                                                     [viewType]="'released'"
                                                     [selectedLoad]="editedLoad"
                                                     (onClick)="loadClick($event)"
                                                     (onRemoveCarrier)="refreshAfterOffer()">
                    </carrier-sales-released-loads-grid>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Lane'">
                <ng-template kendoTabContent>
                    <carrier-sales-lanes-loads-grid [selectedLoad]="editedLoad"
                                                    (onClick)="loadClick($event)">
                    </carrier-sales-lanes-loads-grid>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="'Open Offers'">
                <ng-template kendoTabContent>
                    <open-offer-grid (openOfferLoadClick)="offerLoadClick($event)">
                    </open-offer-grid>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </div>
    <div *ngIf="(editedLoad | json) != '{}'" [ngClass]="(editedLoad | json) != '{}' ? 'col-sm-6 col-lg-7 col-xl-9' : 'col-sm-12'">
        <div class="row" *ngIf="(editedLoad | json) != '{}'">
            <div class="col-sm-12">
                <div class="epi-container">
                    <h4>Stops</h4>
                    <order-stop-grid [quoteOrderID]="editedLoad.quoteOrderID" [quoteOrderLineID]="editedLoad.quoteOrderLineID"
                                     [pageType]="'carriersales'" [pageable]="false" [pageSize]="'all'" [height]="600"
                                     [readonly]="true"></order-stop-grid>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="(editedLoad | json) != '{}' || (editedBookedLoad | json) != '{}'" class="row">
    <div class="col-sm-12">
        <div class="row" *ngIf="offerID==0&&offerBatchID==0">
            <div class="col-sm-12">
                <div class="epi-container">
                    <h4>Carrier Selection</h4>
                    <carrier-list-grid [quoteOrderLineID]="editedLoad.quoteOrderLineID"
                                       [originalQuoteOrderLineID]="originalQuoteOrderLineID"
                                       [loads]="availableLoadsOrig"
                                       [availableLoadsFilter]="availableLoadsFilter"
                                       [viewType]="selectedTab"
                                       [refreshDate]="carrierRefreshDate"
                                       (refreshData)="refreshData($event)"
                                       [bulkTenderLoads]="bulkTenderLoads"
                                       (onCarrierClick)="carrierClick($event)"
                                       (updateEditedLoad)="updateEditedLoad($event)"
                                       (onBulkTenderOfferSave)="bulkTenderOfferSave($event)">
                    </carrier-list-grid>
                </div>
            </div>
            <div class="col-sm-3" *ngIf="false">
                <div class="epi-container">
                    <h4>Carrier Contacts, Lanes</h4>
                    <div class="row">
                        <div class="col-sm-12">
                            <kendo-tabstrip (tabSelect)="onContactsLanesTabSelect($event)" #tabStrip>
                                <kendo-tabstrip-tab [title]="'Contacts'" [selected]="true">
                                    <ng-template kendoTabContent>
                                        <div class="row">
                                            <div class="col">
                                                <carrier-contact-grid [carrierID]="carrierID"></carrier-contact-grid>
                                            </div>
                                        </div>
                                    </ng-template>
                                </kendo-tabstrip-tab>
                                <kendo-tabstrip-tab [title]="'Lanes'">
                                    <ng-template kendoTabContent>
                                        <div class="row">
                                            <div class="col">
                                                <carrier-lane-grid [carrierID]="carrierID"></carrier-lane-grid>
                                            </div>
                                        </div>
                                    </ng-template>
                                </kendo-tabstrip-tab>
                            </kendo-tabstrip>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="offerID==0&&availableLoadsFilter.isBulkTender!=true">
            <div class="epi-container col-sm-12">
                <h4>Offers</h4>
                <carrier-offer-grid [quoteOrderLineID]="editedLoad.quoteOrderLineID"
                                    [refreshDate]="offerRefreshDate"
                                    (refreshData)="refreshData($event)"
                                    [viewType]="selectedTab"
                                    [isAward]="selectedTab!='RFQ'&&selectedTab!='Quotes'"
                                    (onAwardOfferClick)="awardOfferClick($event)"
                                    (onAwardRefresh)="refreshAfterOffer()">
                </carrier-offer-grid>
            </div>
        </div>
        <div class="row m-0" *ngIf="offerID>0||offerBatchID>0">
            <div class="epi-container col-sm-12">
                <h4>Tender Load - Order #{{getOrderNumber()}}</h4>
                <carrier-offer-form [viewType]="selectedTab"
                                    [pageType]="'procurement'"
                                    [offerID]="offerID"
                                    [offerBatchID]="offerBatchID"
                                    (onSaveClick)="refreshAfterOffer()"
                                    (onCancelClick)="cancelOffer()">
                </carrier-offer-form>
            </div>
        </div>
    </div>
</div>

<kendo-dialog *ngIf="isCarrierRepsAssignedStats" [width]="'60%'" [height]="'75%'" (close)="cancelDialogClick('CarrierRepsAssignedStats')">
    <kendo-dialog-titlebar>
        <h2>Assigned Reps</h2>
    </kendo-dialog-titlebar>
    <carrier-reps-assigned-stats-grid></carrier-reps-assigned-stats-grid>
    <kendo-dialog-actions>
        <button (click)="cancelDialogClick('CarrierRepsAssignedStats')" class="btn btn-secondary m-2" mat-button>
            Close
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
